import { render, staticRenderFns } from "./b-tooltip.vue?vue&type=template&id=1ad219ff"
import script from "./b-tooltip.vue?vue&type=script&lang=js"
export * from "./b-tooltip.vue?vue&type=script&lang=js"
import style0 from "./b-tooltip.vue?vue&type=style&index=0&id=1ad219ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports